const TRUSTED_REDIRECT_HOST = 'zocks.io'

// Mirrors isSafeRedirect in the login app (zocks-app-login/src/views/auth/utils.ts) — keep the rules in sync.
export const isSafeRedirect = (url?: string | null): boolean => {
  if (!url) {
    return false
  }
  if (url.startsWith('//') || url.startsWith('\\')) {
    return false
  }
  try {
    const parsed = new URL(url)
    if (parsed.protocol !== 'https:') {
      return false
    }
    const host = parsed.hostname.toLowerCase()
    return host === TRUSTED_REDIRECT_HOST || host.endsWith(`.${TRUSTED_REDIRECT_HOST}`)
  } catch {
    return false
  }
}
